import { BodyM } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'
import getConfig from 'next/config'
import Image from 'next/image'

import { contentLoaderWrapper, loaderImage } from './style.css'
export const FORCED_LOADING_TIME = 2000
export const ContentLoader: React.FC = () => {
  const {
    publicRuntimeConfig: { imageBasePath },
  } = getConfig()
  const { t } = useTranslation()

  return (
    <div className={contentLoaderWrapper}>
      <div>
        <div className={loaderImage}>
          <Image height={124} role="img" src={`${imageBasePath}/images/concepts/time.svg`} width={124} />
        </div>
        <BodyM>{t('save-search:LoaderModal_Description')}</BodyM>
      </div>
    </div>
  )
}
